import React from 'react';
import {Table} from 'semantic-ui-react';

const UserAccountNoSearchResult = props => {
    return (
        <Table.Row>
            <Table.Cell colSpan="6">
                <div className="noResults">
                    No Results Found
                </div>
            </Table.Cell>
        </Table.Row>
    );
};

UserAccountNoSearchResult.propTypes = {
    
};

export default UserAccountNoSearchResult;